import { render, staticRenderFns } from "./Motivos.vue?vue&type=template&id=a1e1275a"
import script from "./Motivos.vue?vue&type=script&lang=js"
export * from "./Motivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports